module.exports = __webpack_public_path__ + "img/Group 600.6d3aa55e.png";